import React from 'react'
import { Row, Col } from 'reactstrap'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

class RecoveryMainForm extends React.Component {
    render() {
        const { t } = this.props
        return (
            <div id="login" className="login loginpage col-md-8 offset-md-2">
                <div className="login-welcome lg-font-size">{t("login-recovery-password")}</div>
                <div className="login-please md-font-size">{t("login-recovery-insert-email")}</div>
                <form
                    name="recoveryMailForm"
                    id="recoveryMailForm"
                    action="#!"
                    method="post"
                    onSubmit={this.props.handleSubmit}
                >
                    <Row>
                        <Col xs={12}>
                            <div>
                                <label htmlFor="user_email">
                                    <span className="login-label sm-font-size">
                                        {t("login-recovery-email-label")}
                                    </span>
                                    <input
                                        type="email"
                                        name="email"
                                        id="user_email"
                                        className="input login-input md-font-size"
                                        value={this.props.email}
                                        onChange={this.props.emailChange}
                                        size="20"
                                        placeholder={t('register-inputMail')}
                                        required
                                    />
                                </label>
                            </div>
                        </Col>
                    </Row>
                    <div className="submit">
                        <button
                            type="submit"
                            name="wp-submit"
                            id="wp-submit"
                            className="btn btn-primary btn-block md-font-size"
                        >{t("login-recovery-get-code")}</button>
                    </div>
                </form>
                <div id="nav" className="login-register-wrapper sm-font-size">
                    <a
                        className="login-register"
                        href="/login"
                    >
                        {t("login-recovery-back-to-login")}
                    </a>
                </div>
            </div>
        )
    }
}

RecoveryMainForm.propTypes = {
    t: PropTypes.func,
    handleSubmit: PropTypes.func,
    email: PropTypes.string,
    emailChange: PropTypes.func,
}

export default withTranslation()(RecoveryMainForm)



// WEBPACK FOOTER //
// ./src/components/Login/RecoveryMailForm.jsx